import { call, put, takeLatest } from "redux-saga/effects";
import {
  editSubjectFailure,
  editSubjectSucess,
  editSubjectStart,
} from "../reducer";
import { Notify } from "@flexisaf/flexibull2";
import { putSubject } from "../../../services/subject";

export function* handleEditSubject({ payload }) {
  const { id, name, description, cb } = payload;

  const response = yield call(putSubject, { id, name, description });
  const { success, raw, message } = response;

  if (success) {
    yield put(editSubjectSucess());
    Notify("Subject edited successfully", { status: "success" });
    if (cb) {
      cb();
    }
  } else {
    yield put(editSubjectFailure(message || raw.error));
    Notify(message || raw.error, { status: "error" });
  }
}

export default function* onEditSubject() {
  yield takeLatest(editSubjectStart.type, handleEditSubject);
}
